module.exports = __webpack_public_path__ + "db15ac7981b2d2897d1a3c22892b5a51.ttf";